'use client';

import type { ComponentProps } from 'react';
import { CalculatorShell } from './CalculatorShell';

/** One card around the whole calculator. Newer ones card each column instead - see `ApySavingsCalculator`. */
export const LegacyCalculatorShell = (props: ComponentProps<typeof CalculatorShell>) => (
  <div className="rounded-xl bg-bg-raised-secondary p-6 sm:p-10">
    <CalculatorShell {...props} />
  </div>
);
